"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZodNullable = void 0;
var ZodTypes_1 = require("../ZodTypes");
var base_1 = require("./base");
var ZodNullable = (function (_super) {
    __extends(ZodNullable, _super);
    function ZodNullable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toJSON = function () { return ({
            t: _this._def.t,
            innerType: _this._def.innerType.toJSON(),
        }); };
        return _this;
    }
    ZodNullable.create = function (type) {
        if (type instanceof ZodNullable)
            return type;
        return new ZodNullable({
            t: ZodTypes_1.ZodTypes.nullable,
            innerType: type,
        });
    };
    return ZodNullable;
}(base_1.ZodType));
exports.ZodNullable = ZodNullable;
//# sourceMappingURL=nullable.js.map